import React from 'react';

import { SKELETON_TOKENS, SkeletonBlock, SkeletonOverlay } from 'components/shared';

const MENU_COUNT = 8;
const CATALOG_COUNT = 4;

// Mirrors styles.tsx: menusTableRoot (wrapping grid) and menuPreviewItemRoot (350×158 card).
const grid: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', padding: '10px 0 0 12px' };
const card: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: 350,
    height: 158,
    margin: '0 0 15px 10px',
    padding: 16,
    boxSizing: 'border-box',
    border: `1px solid ${SKELETON_TOKENS.divider}`,
    borderRadius: SKELETON_TOKENS.radius,
};
const row: React.CSSProperties = { display: 'flex', justifyContent: 'space-between' };

function CardGrid({ count }: { count: number }) {
    return (
        <div style={grid}>
            {Array.from({ length: count }, (_, i) => (
                <div key={i} style={card}>
                    <div style={row}>
                        <SkeletonBlock height={24} width={180} />
                        <SkeletonBlock height={24} width={24} />
                    </div>
                    <div style={row}>
                        <SkeletonBlock height={16} width={40} />
                        <SkeletonBlock height={16} width={60} />
                    </div>
                </div>
            ))}
        </div>
    );
}

export default function MenusSkeleton({
    isLoading,
    style,
}: {
    isLoading: boolean;
    style?: React.CSSProperties;
}) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={style}>
            <CardGrid count={MENU_COUNT} />
            <div
                style={{
                    borderBottom: `1px solid ${SKELETON_TOKENS.divider}`,
                    height: 10,
                    flexShrink: 0,
                }}
            />
            <SkeletonBlock height={10} width={70} style={{ margin: '10px 0 0 22px' }} />
            <CardGrid count={CATALOG_COUNT} />
        </SkeletonOverlay>
    );
}
